export function changeValue(newValue){

	$("."+this.rangeInputClass).val(newValue);

};